import React from "react";
import { Col, Row } from "reactstrap";
import styles from "./SellerHeader.module.scss";
import Textfield from "../../components/Shared/Textfield";

const SellerHeader = ({ title, onSearch }) => {
  return (
    <div className={styles["header_wrapper"]}>
      <p className={styles["header_heading"]}>{title}</p>
      <Row className={styles["header"]}>
        <Col xs={12} className={styles["filters_div"]}>
          <Textfield
            className={`${styles["search_textfield"]}`}
            placeholder="Search"
            onChange={onSearch}
          />
        </Col>
      </Row>
    </div>
  );
};

export default SellerHeader;
